import React, { FC } from "react";

import Image from "next/image";
import Link from "next/link";
import { Space } from "antd";
import it from "public/flags/italy.png";
import usa from "public/flags/usa.png";
import { useRouter } from "next/router";

const LanguageSwitcher: FC = () => {
  const { asPath, locale, locales } = useRouter();

  return (
    <>
      <Space>
        {locales!.map((l, index) => (
          <div key={index} style={l !== locale ? { opacity: 0.4 } : {}}>
            <Link passHref href={asPath} locale={l} legacyBehavior>
              <a title={l}>
                <Image
                  alt={l}
                  width={24}
                  height={24}
                  src={l === "it" ? it : usa}
                />
              </a>
            </Link>
          </div>
        ))}
      </Space>
    </>
  );
};

export default LanguageSwitcher;
